<!--邀请码分享页面-->
<!--wj-->
<template>
    <div class="InvitaCode">
        <img :src="codeImg" class="CodeImg">
        <div class="Invita-Code">
             <el-row class="Invita-row">
                <el-col :span="8" style="padding-right: 1rem;text-align: right;">
                    <img :src="list.umbiLogo" :onerror="logo" class="umbiLogo">
                </el-col>
                <el-col :span="16" style="padding-top: 2.5vw;">
                    <p class="Invita-font">您的好友{{list.umbiName}}</p>
                    <p class="Invita-font">给您推荐了中税网通APP</p>
                </el-col>
            </el-row>
            <p class="yqm">邀请码：{{code}}<span class="codeItem" :data-clipboard-text="code" @click="copyCode()">复制</span></p>
        </div>
        <div style="padding:0 9vw;">
            <el-row class="Invita-row">
                <el-col :span="8" style="padding-right: 1rem;text-align: right;">
                   <img :src="qdImg" class="Invita-logo">
                </el-col>
                <el-col :span="16">
                    <p style="font-size:6vw;"><strong>中税网通APP2.0</strong></p>
                    <p class="Invita-font">互联网+涉税服务平台</p>
                </el-col>
            </el-row>
            <button type="button" class="code-btn" @click="download()">立即下载</button>
             <img :src="Img" style="padding:8vw 0 4vw 0;">
        </div>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from 'axios';
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
export default {
    components: {
        ShareWechat
    },
    data(){
        return {
            logo:'this.src="' + require("@/assets/image/tx3.svg") + '"',
            codeImg:require('@/assets/image/code.jpg'),
            code:'',
            umuId:'',
            list:[],
            Img:require('@/assets/image/eight.svg'),
            qdImg:require('@/assets/image/qd.png')
        };
    },
    mounted(){
        const that = this;
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
          if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                var id = strs[2];
                var list = id.split("&");
                var umu = list[1].split("=");
                var codes = list[0].split("=");
                that.code = codes[1];
                that.umuId = umu[1];
          }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            var id = strs[1];
            var list = id.split("&");
            var umu = list[1].split("=");
            var codes = list[0].split("=");
            that.code = codes[1];
            that.umuId = umu[1];
            //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
          }
        }
        var param ={
            umuId:that.umuId
        }
        Axios.post(that.$store.state.APIURS+"umbi/findById",param).then(function(res) {
            if(res.data.code == 200){
                that.list = res.data.data;
            }
        });
        var shareList={
            title: "邀请好友",
            content: "邀请好友，积分兑换商品！",
        }
        eventBus.$emit("shareList",shareList);
    },
    methods:{
        // 复制邀请码
        copyCode(){
            const that = this;
            var clipboard = new this.Clipboard('.codeItem');
            clipboard.on('success', e => {
                that.$toast({message: "复制成功！", type: "success",position: "bottom",duration: "2000"}); 
                    // 释放内存  
                    clipboard.destroy();  
            })  
            clipboard.on('error', e => {
                 // 不支持复制  
                that.$toast({message: "复制失败！", type: "success",position: "bottom",duration: "2000"}); 
                 // 释放内存  
                clipboard.destroy(); 
            })  
        },
        // 下载
        download(){
            const that = this;
            location.href='http://url.cn/59TtsAP';
        },
    },
};
</script>